import { useMemo, useState } from 'react';
import { periodRange, type StatsWindow } from '../../lib/time';
import { PS, T } from '../../lib/theme';
import { RevenueSection } from './RevenueSection';
import { BookingsSection } from './BookingsSection';
import { OccupancySection } from './OccupancySection';
import { MembersSection } from './MembersSection';

const WINDOWS: { key: StatsWindow; label: string }[] = [
  { key: '7d', label: '7 days' },
  { key: '30d', label: '30 days' },
  { key: '90d', label: '90 days' },
  { key: 'month', label: 'This month' },
];

export function StatsPage() {
  const [win, setWin] = useState<StatsWindow>('30d');
  const { start, end } = useMemo(() => periodRange(win), [win]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <header style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <h1 style={{ ...T.sectionTitle, margin: 0 }}>Stats</h1>
        <div style={{ display: 'flex', gap: 6 }}>
          {WINDOWS.map((w) => {
            const active = w.key === win;
            return (
              <button
                key={w.key}
                onClick={() => setWin(w.key)}
                aria-pressed={active}
                style={{
                  background: active ? PS.red : PS.white,
                  color: active ? PS.white : PS.nearBlack,
                  border: `1px solid ${active ? PS.red : PS.border}`,
                  padding: '8px 12px',
                  borderRadius: 3,
                  cursor: 'pointer',
                  minHeight: 40,
                  ...T.navLink,
                  textTransform: 'uppercase' as const,
                }}
              >
                {w.label}
              </button>
            );
          })}
        </div>
        <span style={{ ...T.caption, color: PS.textSec }}>
          {start} → {end}
        </span>
      </header>

      <RevenueSection start={start} end={end} />
      <BookingsSection start={start} end={end} />
      <OccupancySection start={start} end={end} />
      <MembersSection start={start} end={end} />
    </div>
  );
}
